<script setup lang="ts">
import { ProductTypes } from "~/types";
import { useAuthStore } from "~/stores/auth/store";
import TrainingStats from "~/components/Training/TrainingStats.vue";
import VideoPlayer from "~/components/VideoPlayer.vue";

const authStore = useAuthStore();
</script>

<template>
  <div class="relative">
    <div class="relative mx-auto">
      <div class="mb-10">
        <div class="mx-auto w-full lg:max-w-[1024px]">
          <VideoPlayer
            id="WWyWCUlI"
            :duration="20"
            video-type="vod"
            :progress="0"
            source="https://cdn.jwplayer.com/v2/media/WWyWCUlI"
            :track-progress="false"
          />
        </div>
      </div>

      <div class="mx-4 mb-20 flex flex-col items-center text-center lg:mx-0">
        <div>
          <div class="text-bold mb-5 text-4xl">
            Your favorite poker shows are here!
          </div>
          <div class="mb-5 text-surface-300">
            Gain an edge over the competition with our VIP Training Package,
            specially<br />designed for the most dedicated poker enthusiasts.
          </div>
          <NuxtLink
            v-if="authStore.subscription.interval === ProductTypes.NONE"
            to="/register/select-plan"
            class="glowing-btn mb-4 h-14 w-80"
          >
            <Button
              label="Join PokerGO VIP"
              severity="secondary"
              :pt-options="{ mergeProps: true }"
              :pt="{
                root: 'bg-white border-white',
                label: 'text-black',
              }"
            />
          </NuxtLink>
          <NuxtLink
            v-else-if="authStore.subscription.store === 'stripe'"
            to="/account/change-plan?plan=training_annual"
            class="glowing-btn mb-4 h-14 w-80 text-base"
          >
            <Button
              label="Upgrade to PokerGO VIP"
              severity="secondary"
              :pt-options="{ mergeProps: true }"
              :pt="{
                root: 'bg-white border-white',
                label: 'text-black',
              }"
            />
          </NuxtLink>
        </div>
      </div>

      <TrainingStats class="mb-20" />

      <ToughestPros />
    </div>
  </div>
</template>

<style scoped></style>
